import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { GroupsDashboardsNavDrawer as _GroupsDashboardsNavDrawer } from "components";

const GroupsDashboardsNavDrawerComponent = React.memo(
  _GroupsDashboardsNavDrawer
);

const GroupsDashboardsNavDrawer = (props) => {
  const dashboards = useSelector((state) => state.isx.dashboards);
  const orgs = useSelector((state) => state.isx.orgs);
  const user = useSelector((state) => state.isx.user);

  const params = useParams();
  const dashboardId = params.dashboardGuuid;

  return (
    <GroupsDashboardsNavDrawerComponent
      open={props.open}
      closeDrawer={props.closeDrawer}
      addDashboard={props.addDashboard}
      dashboards={dashboards}
      dashboardId={dashboardId}
      orgs={orgs}
      user={user}
    />
  );
};

export default GroupsDashboardsNavDrawer;
